// import { Component } from '@angular/core';
import {Component, Inject} from '@angular/core';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  
  MatDialogModule,
} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import { CommonModule } from '@angular/common';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { TranslateService } from '@ngx-translate/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-video-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule, 
    MatButtonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    TranslateModule,
    MatToolbarModule,
  ],
  templateUrl: './video-dialog.component.html',
  styleUrl: './video-dialog.component.css'
})
export class VideoDialogComponent {
  showVideo = false;
  videoUrl = '';
  constructor(@Inject(MAT_DIALOG_DATA) 
    public data: any,
    translate: TranslateService,
  ) {
    let browserLangToUse = '';
    let browserLang = translate.getBrowserCultureLang();
    browserLangToUse = browserLang === undefined ? 'en' : browserLang;
    console.log(browserLang);    
    translate.setDefaultLang('en');    
    translate.use(browserLangToUse);
  }
  ngOnInit(): void {
    this.videoUrl = this.data.kpi?.videoUrl;
    this.showVideo = true;
  }
}
